export const getAllByTestId = (container: HTMLDivElement, testId: string) =>
  container.querySelectorAll(`[data-test-id=${testId}]`);
